import { useNavigate } from "react-router-dom"
import { Data } from "../../../../../features/data-types"
import { Action, Modal, ModalId, useUIActions } from "../../../../../features/ui"
import { PurchaseOrder, usePurchaseHooks } from "../../../../purchases"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { useEffect, useState } from "react"
import { operationHelpers } from "../../../../operations"

type Props = {
    data?: Data
    purchase: PurchaseOrder
    onSubmit: (data: Data) => void
}

export const TicketAmountDiffersModal = (props: Props) => {
    const { data, purchase, onSubmit } = props

    const [isPurchaseEditable, setIsPurchaseEditable] = useState(false)

    const { describeCode } = operationHelpers
    const { isEditable } = usePurchaseHooks()
    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const { closeModal } = useUIActions()

    useEffect(() => {
        isEditable(purchase).then(setIsPurchaseEditable)
    }, [purchase])

    const renderBody = () => <div>
        Los montos de la factura difieren de los montos de la Compra {describeCode(purchase)}.
        Deseas subir la factura parcial{isPurchaseEditable ? ' o corregir la compra' : ''}?
    </div>

    const handleSubmit = () => {
        data && onSubmit(data)
    }

    const onFixPurchase = () => {
        closeModal(ModalId.TICKET_AMOUNT_DIFFERS)
        navigate(`${getRoutePath(RoutePath.PURCHASES, purchase.id)}/${RoutePath.EDIT}`)
    }

    const onCancel = () => closeModal(ModalId.TICKET_AMOUNT_DIFFERS)

    const actions: Action[] = [
        {
            label: 'Subir Factura Parcial',
            kind: 'primary',
            onClick: handleSubmit
        },
        {
            label: isPurchaseEditable ? 'Corregir Compra' : 'Cancelar',
            kind: 'tertiary',
            onClick: isPurchaseEditable ? onFixPurchase : onCancel
        }
    ]

    return (
        <Modal
            modalId={ModalId.TICKET_AMOUNT_DIFFERS}
            title="Diferencia de Montos"
            actions={actions}
        >
            {renderBody()}
        </Modal>
    )
}
